import { MutationTree } from 'vuex';
import { SettingState, SystemSetting } from './types';
import * as types from './mutation-types';
import { ErrorDetail } from '../../types';

export const mutations: MutationTree<SettingState> = {
    // システム設定取得系
    [types.SHOW_START](state) {
        const showState = state.show;
        showState.error = false;
        showState.errorCode = undefined;
        showState.errorMsg = undefined;
        showState.isProcessing = true;
        showState.isFetchSuccess = false;
    },

    [types.SHOW_SUCCESS](state, payload: SystemSetting) {
        state.systemSetting = payload;

        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = true;
    },

    [types.SHOW_FAILURE](state, payload: { code: string; message: string }) {
        const showState = state.show;
        showState.errorCode = payload.code;
        showState.errorMsg = payload.message;
        showState.error = true;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;
    },

    // システム設定更新系
    [types.UPDATE_START](state) {
        const updateState = state.update;
        updateState.error = false;
        updateState.errorTitle = undefined;
        updateState.errorDetails = undefined;
        updateState.isProcessing = true;
    },

    [types.UPDATE_SUCCESS](state) {
        const updateState = state.update;
        updateState.isProcessing = false;
    },

    [types.UPDATE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const updateState = state.update;
        updateState.errorTitle = payload.errorTitle;
        updateState.errorDetails = payload.errorDetails;
        updateState.error = true;
        updateState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;

        const updateState = state.update;
        updateState.isProcessing = false;
    },

    [types.CLEAR_ALL](state) {
        state.systemSetting = undefined;

        const showState = state.show;
        showState.category = undefined;
        showState.error = false;
        showState.errorCode = undefined;
        showState.errorMsg = undefined;
        showState.isProcessing = true;
        showState.isFetchSuccess = false;

        const updateState = state.update;
        updateState.category = undefined;
        updateState.error = false;
        updateState.errorTitle = undefined;
        updateState.errorDetails = undefined;
        updateState.isProcessing = false;
    },
};
